// extracted by mini-css-extract-plugin
export default {"info_card":"QuoteModal_info_card__uFA4l"};